import sections from './sections'
import { pageMetadataFields } from './_shared'

export const getFields = (fallbackRegions?: string[]) => {
  if (!fallbackRegions?.length) {
    return pageMetadataFields
  }

  // For production builds, use ultra-minimal query to avoid 300KB limit
  if (process.env.NODE_ENV === 'production') {
    const sectionsSchema = fallbackRegions.map(region => {
      const fieldName = `sections.${region.replace('-', '_')}Sections`
      return `
        "${region}": ${fieldName}[]._ref
      `
    }).join(',')

    return `
      ${pageMetadataFields},
      "sections": {
        ${sectionsSchema}
      }
    `
  }

  // For development, use the full query
  const sectionsSchema = fallbackRegions.map(region => {
    const fieldName = `sections.${region.replace('-', '_')}Sections`
    return `
      "${region}": select(
        length(${fieldName}) > 0 => ${fieldName}[] -> {
          ${sections.getFields()}
        },
        []
      )
    `
  }).join(',')

  return `
    ${pageMetadataFields},
    "sections": {
      ${sectionsSchema}
    }
  `
}

export const getSections = () => {
  return `
    ${sections.fragment('sections')}   
  `
}

const exported = {
  getFields,
  getSections,
}

export default exported
